<template>
  <div class="dialog-wrap">
    <el-dialog
      title="专业添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="780px">
      <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
        <el-form-item label="专业名称" prop="keyword">
          <el-input v-model="query.keyword" size="mini" placeholder="输入专业名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" size="mini" placeholder="请选择">
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button class="submit" size="mini" @click="handleFormReset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          width="60"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="专业名称"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="code"
          label="专业代码"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          width="120"
          align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == 1?'success':'danger'"
            >{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { collegeMajorUsableList, collegeMajorCreate } from '@/api/common'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    college: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      query:  {
        keyword: '',
        status: '',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1
      },
      pageTotal: 10,
      filter: {
        status: [
          {label: '全部', value: ''},
          {label: '正常', value: '1'},
          {label: '关闭', value: '0'}
        ],
      },
      results: [],
      selections: []
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchMajorList()
      }
    }
  },
  methods: {
    // 专业列表请求
    fetchMajorList() {
      let params = {...this.query}
      params.college_code = this.college.code
      collegeMajorUsableList(params).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchMajorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchMajorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchMajorList()
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val
    },
    handleSubmit() {
      const params = {
        majors: this.selections.map(item => ({major_code: item.code, college_code: this.college.code}))
      }
      collegeMajorCreate(params).then(res => {
        this.$message.success(`添加成功`)
        this.$emit('submit')
        this.handleClose()
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .search-wrap {
      margin-bottom: -18px;
    }
    .result {
      margin-top: 10px;
    }
    .footer {
      margin-top: 10px;
    }
  }
</style>
